// Central registry of data-testid values used across ClauseClock shells.
export const NAV = {
  brand: "nav-brand",
  dashboard: "nav-dashboard",
  contracts: "nav-contracts",
  actionCenter: "nav-action-center",
  addContract: "nav-add-contract",
};

export const DASHBOARD = {
  root: "dashboard-page",
  emptyAddContract: "dashboard-empty-add-contract",
  emptySample: "dashboard-empty-sample",
  metrics: "dashboard-metrics",
  contractsMonitored: "dashboard-contracts-monitored",
  valueUnderTracking: "dashboard-value-under-tracking",
  confirmedValueProtected: "dashboard-confirmed-value-protected",
  pendingValue: "dashboard-pending-value",
  windowsMissed: "dashboard-windows-missed",
  remindersDue: "dashboard-reminders-due",
  valueByContract: "dashboard-value-by-contract",
  savingsReportBtn: "dashboard-savings-report-btn",
  needsReview: "dashboard-needs-review",
  lapsed: "dashboard-lapsed",
  attention: "dashboard-attention",
  portfolio: "dashboard-portfolio",
};

export const TIMELINE = { root: "contract-timeline" };

export const CONTRACTS = {
  root: "contracts-page",
  emptyAddContract: "contracts-empty-add-contract",
};

export const CONTRACT_DETAIL = { root: "contract-detail-page" };
export const FINDING_DETAIL = { root: "finding-detail-page" };
export const ACTION_CENTER = { root: "action-center-page" };
export const UPLOAD = { root: "upload-page" };
export const ACCURACY = { root: "accuracy-page" };
export const DEMO = { root: "demo-page", banner: "demo-synthetic-banner" };
